import { gql, useQuery } from '@apollo/client'
import { Query, RetailerAccount } from '@promoboxx/graphql-gateway-types'
import { useSelector } from 'react-redux'

import { currentRetailerAccountSelector } from '@src/stores/app/selectors'

export const GET_LEADS = gql`
  query GetLeads(
    $resourceType: String!
    $resourceId: ID!
    $params: LeadsListParams
    $fields: [String!]
  ) {
    getLeadsList(
      resource_type: $resourceType
      resource_id: $resourceId
      params: $params
    ) {
      id
      custom_data {
        name
        value
      }
      campaign_id
      created_at
      updated_at
      retailer_id
      brand_id
      deleted_at
      lead_import_id
      created_by_id
      updated_by_id
      email_address
      first_name
      last_name
      event_id
      consumer_id
      disposition
      share_setting_id
      state
    }
    getLeadImports(
      resource_type: $resourceType
      resource_id: $resourceId
      fields: $fields
    ) {
      id
      brand_id
      retailer_id
      name
      description
      created_at
      updated_at
      manual_input
      completed_at
      method_choice
      import_file_name
      import_content_type
      import_file_size
      import_updated_at
      created_by_id
      updated_by_id
      deleted_at
      error_at
      leads_count
      leads_unsubscribed_count
    }
  }
`

export function useRetailerAccountLeads() {
  const retailerAccount: RetailerAccount | undefined = useSelector(
    currentRetailerAccountSelector,
  )
  const query = useQuery<Query>(GET_LEADS, {
    variables: {
      resourceId: retailerAccount?.id,
      resourceType: 'retailer_accounts',
      fields: ['leads_count', 'leads_unsubscribed_count'],
      params: {
        filters: {
          by_state: 'unsubscribed',
        },
      },
    },
    skip: !retailerAccount?.id,
  })

  return {
    leadsImports: query.data?.getLeadImports,
    leads: query.data?.getLeadsList,
    loading: query.loading,
    refetch: query.refetch,
  }
}
